import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldMetadata, ViewMetadata } from '@data/cer-data-types';

export class VoucherPostingVendorForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {
    const navVendor = this.routeOptions.navigation?.columnNameChild == 'projectNum';
    const view = VoucherPostingVendorForm.viewGet(navVendor);
    viewSet.viewAdd(view);
  }

  public static viewGet(navVendor: boolean): CerFormView {

    const view = new CerFormView();
    view.viewMetadata = VoucherPostingVendorForm.viewMetadata;
    view.fieldMetadata = VoucherPostingVendorForm.fieldMetadata;
    if (navVendor) {
      const hideCols = ['projectNum', 'projectName'];
      view.fieldMetadata.filter(f => hideCols.includes(f.name)).forEach(f => f.visible = false);
    }
    return view;
  }

  // View
  public static viewMetadata: ViewMetadata = {
    name: 'project-voucher', dataApiName: 'VoucherPostingVendor',
    text: 'Projekt bilag', titleFields: ['voucherNum', 'accountNum'],
    allowEdit: false, allowDelete: false, allowCreate: false,
    primaryKey: 'id', baseFields: ['id', 'history'],
    navigations: [
      { link: 'nav', foreignKey: { parentEntity: 'Voucher', parentColumn: 'id', column: 'voucherId' } },
      { link: 'nav', foreignKey: { parentEntity: 'VendorView', parentColumn: 'num', column: 'vendorNum' } },
      { link: 'nav', foreignKey: { parentEntity: 'RefDataProduct', parentColumn: 'num', column: 'productNum' } }
    ]
  };

  public static fieldMetadata: FieldMetadata[] = [
    { name: 'id', text: "Kontering id", format: 'Integer', width: '90px', visible: false },
    { name: 'transDate', text: "Dato", format: 'DateShort', width: '100px', orderBy: 'Descending' },
    //{ name: 'documentDate', text: "Document dato", format: 'DateShort', visible: false, width: '100px' },
    { name: 'amountCur', text: "Beløb", format: 'Amount', width: '100px' },
    { name: 'currency', text: "Valuta", width: '60px', foreignKeyType: 'currencyId' },
    { name: 'lineNum', text: "Linjenr.", format: 'Integer', width: '90px', visible: false },
    { name: 'vendorNum', fieldType: 'vendor', width: '120px', visible: true },
    { name: 'vendorName', text: 'Kreditornavn', width: '120px', visible: true, foreignKeyUsing: 'vendorNum' },
    { name: 'postingAmountCost', text: "Kontering omk.", format: 'Amount', width: '100px' },
    { name: 'postingAmountCur', text: "Kontering beløb", format: 'Amount', width: '100px', visible: false },
    { name: 'postingType', text: "Kontering type", width: '60px' },
    { name: 'postingAccountNum', text: "Kontering", width: '60px' },
    { name: 'postingAccountDesciption', text: "Kontering navn", width: '120px' },
    { name: 'productNum', text: "ISBN", width: '120px', visible: false, foreignKeyType: 'refDataProduct' },
    { name: 'productResponsible', text: "Redaktør", fieldType: 'userShortName' },
    { name: 'approver', text: "Godkender", width: '70px', foreignKeyType: 'user' },
    { name: 'status', text: "Status", visible: false, width: '80px', foreignKeyType: 'voucherApprovalStatus' },
    { name: 'voucherNum', text: "Bilagsnr.", width: '100px' },
    { name: 'documentNum', text: "Fakturanr.", width: '100px' },
    { name: 'msgId', text: "Besked id", format: 'Integer', visible: false, width: '90px' },
    { name: 'voucherId', text: "Bilag id", format: 'Integer', visible: false, width: '90px' },
    { name: 'taxCode', text: "Momskode", width: '65px', fieldType: 'financeTaxCode', visible: false },
    { name: 'department', text: "Afdeling", width: '60px', visible: false },
    { name: 'postedStatus', text: "Bogføring", width: '100px', visible: false },
    { name: 'txt', text: "Posteringstekst", width: '120px', visible: false }
  ];
}
